import { render } from "./NotionRichText.vue?vue&type=template&id=95e4a324&scoped=true"
import script from "./NotionRichText.vue?vue&type=script&lang=js"
export * from "./NotionRichText.vue?vue&type=script&lang=js"

import "./NotionRichText.vue?vue&type=style&index=0&id=95e4a324&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95e4a324"]])

export default __exports__